import { Locator } from "@readium/shared";
export function toLocatorJson(locator) {
    return locator.serialize();
}
export function fromLocatorJson(json) {
    if (typeof json !== "object" || json === null)
        return undefined;
    return Locator.deserialize(json);
}
/** Progression globale dans le livre, entre 0 et 1, si connue. */
export function totalProgression(locator) {
    const value = locator.locations?.totalProgression;
    return typeof value === "number" ? Math.min(1, Math.max(0, value)) : undefined;
}
//# sourceMappingURL=locator.js.map